import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgPaginatorModule } from "../../../ng-shared/ng-components/ng-paginator/ng-paginator.module";
import { NgTCIPipeModule } from "../../ng-directives/ng-tci-pipe/ng-tci-pipe.module";
import { NgWaitModule } from "../../../ng-shared/ng-components/ng-wait/ng-wait.module";

import { NgAlertComponent } from "./ng-alert.component";
import { NgAlertService } from "./ng-alert.service";
import { Http } from "@angular/http";
import {
    DialogModule,
    DropdownModule,
    TooltipModule
} from "primeng/primeng";

function NgAlertServiceFactory(http: Http): NgAlertService {
    return NgAlertService.getInstance(http);
}

@NgModule({
    imports: [
        CommonModule,
        NgWaitModule,
        ReactiveFormsModule,
        RouterModule,
        DialogModule,
        DropdownModule,
        TooltipModule,
        NgTCIPipeModule,
        FormsModule,
        NgPaginatorModule
    ],
    declarations: [
        NgAlertComponent
    ],
    providers: [
        {
            provide: NgAlertService,
            useFactory: NgAlertServiceFactory,
            deps: [
                Http
            ]
        }
    ],
    exports: [
        NgAlertComponent
    ]
})
export class NgAlertModule {
}
